module.exports = __webpack_public_path__ + "img/graphics-10.34d126c0.svg";